<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'HELP'" [breadcrumb]="''" [count]="0"
  icon="fa-question-circle">
</app-breadcrumb>
<div class="row montserrat">
  <div class="col-sm-5 col-md-4 col-lg-5 col-xl-2" style="padding-right:0;">
    <div class="panelbar-wrapper">
      <kendo-panelbar #helpPanelBar (stateChange)="stateChange($event)">
        <kendo-panelbar-item id="documents" title="{{'HELP-DOCUMENTS' | translate}}"
          [selected]="selectedItem === 'documents'">
        </kendo-panelbar-item>
        <kendo-panelbar-item *ngIf="isShowHelp" id="import-members"
          title="{{'HELP-IMPORT-MEMBERS' | translate:patientLabel}}" [selected]="selectedItem === 'import-members'">
        </kendo-panelbar-item>
        <kendo-panelbar-item *ngIf="communityEnabled && (isShowHelp || isDirectoryManager)"
          id="import-community-programs" title="{{'HELP-IMPORT-COMMUNITY-PROGRAMS' | translate}}"
          [selected]="selectedItem === 'import-community-programs'">
        </kendo-panelbar-item>
        <kendo-panelbar-item *ngIf="isShowHelp || isDirectoryManager" id="import-providers"
          title="{{'HELP-IMPORT-PROVIDERS' | translate}}" [selected]="selectedItem === 'import-providers'">
        </kendo-panelbar-item>
      </kendo-panelbar>
    </div>
  </div>
  <div class="col-sm-7 col-md-8 col-lg-7 col-xl-10">
    <div class="mt-4 mr-4">
      <app-help-import-members *ngIf="selectedItem === 'import-members'" [language]="language"
        [patientLabel]="patientLabel">
      </app-help-import-members>
      <app-help-import-providers *ngIf="selectedItem === 'import-providers'" [language]="language">
      </app-help-import-providers>
      <app-help-import-community-programs *ngIf="selectedItem === 'import-community-programs'" [language]="language">
      </app-help-import-community-programs>
      <app-help-documents *ngIf="selectedItem === 'documents'" [language]="language">
      </app-help-documents>
    </div>
  </div>
</div>